<template>
  <el-col class="mb-2 p-0 px-0" :span="24">
    <div class="row m-0">

      <el-row :gutter="$vuetify.display.width > 1770 ? 10 : 10">

      

      <!-- session or unallocated sessions tab -->
      <el-col
        :span="$vuetify.display.width > 1770 ? 5 : $vuetify.display.width > 1293 ? 8 : 22"
        :class="'x-start order-1 mb-10'"
      >
        <el-radio-group
          v-model="sessionFilter"
          text-color="#ffff"
          fill="#234B49"
          :class="$vuetify.display.width < 750 ? 'width-100-p' : ''"
        >
          <el-radio-button
            class="start-period all-group-by text-center"
            label="vehicles"
            :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
            :style="$vuetify.display.width < 630 ? 'max-width: 40%; padding-left: 10px; padding-right: 0px;' : ''"
          >
            Vehicles
          </el-radio-button>
          <el-radio-button
            class="site-group-by text-center end-period"
            label="unallocated_vehicles"
            :class="$vuetify.display.width < 750 ? 'width-50-p' : ''"
            :style="$vuetify.display.width < 630 ? 'max-width: 60%; padding-left: 0px; padding-right: 0px;' : ''"
          >
            {{
              $vuetify.display.width < 500
                ? "Unallocated Veh."
                : "Unallocated Vehicles"
            }}
          </el-radio-button>
        </el-radio-group>
      </el-col>

      <!-- Sort by tabs -->
      <el-col
        :span="$vuetify.display.width > 1770 ? 8 : $vuetify.display.width > 1293 ? 14 : 24"
        :class="$vuetify.display.width > 1293 ? 'x-center order-2 mb-10' : 'x-start order-3 mb-10'"
      >
        <el-tooltip
             effect="light"
             placement="top"
             show-after="500"
             hide-after="300"
             >
             <template #content >
                <span :style="{fontSize: '12px', textAlign: 'left'}">Sort By</span>
            </template>
            <el-select
              v-model="selected_order_by[sessionFilter]"
              placeholder="Select"
              style="min-width: 117px; height: 40px;"
              class="fleetAnalyticsTables-select"
              @change="handleRefresh"
            >
              <template #label>
                <span>Sort by: </span>
                <span style="font-weight: bold">{{ convertTabToTitleCase(order_by_tabs) }}</span>
              </template>
              <el-option
                v-for="(item, index) in order_by_dropdown[order_by_dropdown_helper][this.sessionFilter == 'vehicles' ? 'vehicles_order_by' : 'unallocated_vehicles_order_by']"
                :key="index"
                :label="convertTabToTitleCase(item).replace('Site Title', 'Site Name').replace('Id', 'ID').replace('_', ' ')"
                :value="item"
              />
            </el-select>

        </el-tooltip>
        <el-tooltip
             effect="light"
             placement="top"
             show-after="500"
             hide-after="300"
             >
             <template #content >
                <span :style="{fontSize: '12px', textAlign: 'left'}">Sort Direction</span>
            </template>
        <el-radio-group
          v-model="selected_order_direction[sessionFilter]"
          text-color="#ffff"
          fill="#234B49"
          :class="$vuetify.display.width < 950 ? '' : ''"
          :style="$vuetify.display.width < 950 ? 'white-space: nowrap; width: 200px; max-width: 200px;' : ''"
          @change="handleRefresh"
        >
          <el-radio-button
            v-for="(item, index) in order_by_dropdown['order_direction_tab']"
            :key="index"
            class="start-period all-group-by text-center"
            :label="item"
            :class="
              $vuetify.display.width < 950
                ? sessionFilter == 'unallocated_vehicles'
                  ? 'width-50-p'
                  : 'width-50-p'
                : ''
            "
            :style="$vuetify.display.width < 630 ? sessionFilter == 'unallocated_vehicles' ? 'max-width: 50%' : 'max-width: 50%' : ''"
          >
            {{ item }}
          </el-radio-button>
        </el-radio-group>
        </el-tooltip>
      </el-col>

      <!-- mix search bar when selectedGroupBy == 1 with select -->
      <el-col
            v-if="selectedGroupBy == 1"
                :span="$vuetify.display.width > 1770 ? 10 : 24"
                :class="$vuetify.display.width > 1770 ? 'x-start order-2 mb-10' : 'x-start order-4 mb-10'"
              >
              <el-input
                size="large"
                v-model="search"
                :placeholder="searchBytabs == 'site_name' ? 'Type to search by Site Name' : searchBytabs == 'port_id' ? 'Type to search by Port ID' : searchBytabs == 'postcode' ? 'Type to search by Postcode' : searchBytabs == 'description' ? 'Type to search by Description' : searchBytabs == 'usage' ? 'Type to search by Usage' : 'Type to search by site name, charger ID, port ...'"
                :prefix-icon="Search"
                class="mixedSearchBar"
                id="mixedSearchBar-input"
                clearable
                @clear="handleRefresh"
                >
                  <template #prepend >
                    <!-- search_by select -->
                    <el-tooltip
                      effect="light"
                      placement="top"
                      show-after="500"
                      hide-after="300"
                      >
                      <template #content > 
                          <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                      </template>

                      <el-select
                        v-model="searchBytabs"
                        placeholder="Select"
                        style="min-width: 117px; height: 40px;"
                        class="mixedSearchBar-select"
                      >
                        <template #label>
                          <span>Search by: </span>
                          <span style="font-weight: bold">{{ convertTabToTitleCase(searchBytabs) }}</span>
                        </template>
                        <el-option
                          v-for="(item, index) in search_by_dropdown[order_by_dropdown_helper][this.sessionFilter == 'vehicles' ? 'vehicles_search_by' : 'unallocated_vehicles_search_by']"
                          :key="index"
                          :label="convertTabToTitleCase(item).replace('Site Title', 'Site Name').replace('Id', 'ID').replace('_', ' ')"
                          :value="item"
                        />
                      </el-select>
                    </el-tooltip>
                  </template>
                  
                  <template #append>
                    <!-- <el-button :icon="Search" /> -->
                    <el-button
                        @click.stop="handleRefresh"
                        class="newSearchButtonClass"
                      >
                      <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                    </el-button>
                  </template>
              </el-input>
      </el-col>
      <!-- mix search bar -->

      <!-- mix search bar when selectedGroupBy != 1 without select -->
      <el-col
            v-else
                :span="$vuetify.display.width > 1770 ? 10 : 24"
                :class="$vuetify.display.width > 1770 ? 'x-start order-2 mb-10' : 'x-start order-4 mb-10'"
              >
              <el-input
                size="large"
                v-model="search"
                :placeholder="selectedGroupBy == 3 ? 'Type to search by Charger' : selectedGroupBy == 4 ? 'Type to search by Charging Site' : selectedGroupBy == 5 ? 'Type to search by Description' : selectedGroupBy == 2 ? 'Type to search by Region(State)' : 'Type to search by site name, charger ID, port ...'"
                :prefix-icon="Search"
                class="mixedSearchBar-2"
                id="mixedSearchBar-input-2"
                clearable
                @clear="handleRefresh"
                >                  
                  <template #append>
                    <!-- <el-button :icon="Search" /> -->
                    <el-button
                        @click.stop="handleRefresh"
                        class="newSearchButtonClass"
                      >
                      <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                    </el-button>
                  </template>
              </el-input>
      </el-col>
      <!-- mix search bar -->

      <!-- download excel button -->
      <el-col
        :class="$vuetify.display.width > 1770 ? 'justify-content-end order-4' : $vuetify.display.width > 1293 ? 'justify-content-end order-3' : 'justify-content-end order-2 width-100-p'"
        :span="$vuetify.display.width > 1770 ? 1 : $vuetify.display.width > 1293 ? 1 : 1"
      >
        <el-tooltip
          effect="light"
          placement="top"
          show-after="500"
          hide-after="300"
          >
          <template #content > 
              <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Download excel file" }} </span>
          </template>
          <el-button
            @click="handleExportFile"
            class="new-download-file-btn new-button-behavior"
          >
            <svg class="width-40 height-40">
              <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
            </svg>
          </el-button>
        </el-tooltip>
      </el-col>
      </el-row>
      

    </div>
  </el-col>

  <!-- table -->
  <el-col :span="24">
    <div
      class="ma-0"
      v-loading="loading"
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
    <div class="custom-table-design">
      <el-table
        v-if="selectedGroupBy == '1'"
        :data="sessionDataList"
        :fit="true"
        height="300"
        class="my-2 width-100-p data-table"
        stripe
        scrollbar-always-on: false
      >
        <!-- <el-table-column
          v-if="
            sessionFilter == 'unallocated_vehicles' &&
            $store.state.auth.user != null &&
            !$store.state.auth.user.is_auditor
          "
          type="selection"
          width="55"
        /> -->
        <el-table-column
          v-if="
            $store.state.auth.user != null && $store.state.auth.user.is_admin
          "
          :label="'Customer'"
          :prop="'full_name'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Vehicle ID'"
          :prop="'vehicle_id'"
          :width="$vuetify.display.width <= 1900 ? 170 : ''"
          sortable
        />
        <el-table-column
          :label="'Make'"
          :prop="'make'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Model'"
          :prop="'model'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Vehicle Type'"
          :prop="'vehicle_type'"
          :width="$vuetify.display.width <= 1900 ? 150 : ''"
          sortable
        />
        <el-table-column
          :label="'Manufacture Year'"
          :prop="'manufacture_year'"
          :width="$vuetify.display.width <= 1900 ? 180 : ''"
          sortable
        />
        <el-table-column
          :label="'License Plate'"
          :prop="'license_plate'"
          :width="$vuetify.display.width <= 1900 ? 180 : ''"
          sortable
        />
        <el-table-column
        v-if="sessionFilter == 'vehicles'"
          :label="'Created At'"
          :prop="'created_at'"
          :width="$vuetify.display.width <= 1900 ? 180 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.created_at == null
                ? ""
                : (scope.row.created_at).replace("T", " ")
            }}
          </template>
        </el-table-column>
        <el-table-column
        v-if="sessionFilter == 'vehicles'"
          :label="'Updated At'"
          :prop="'updated_at'"
          :width="$vuetify.display.width <= 1900 ? 180 : ''"
          sortable
        >
          <template #default="scope">
            {{
              scope.row.updated_at == null
                ? ""
                : (scope.row.updated_at).replace("T", " ")
            }}
          </template>
        </el-table-column>
        <el-table-column
          :label="'Site Name'"
          :prop="sessionFilter == 'vehicles' ? 'title' : 'site_title'"
          :width="$vuetify.display.width <= 1900 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Asset ID'"
          :prop="'asset_id'"
          :width="$vuetify.display.width <= 1900 ? 150 : ''"
          sortable
        />
        <el-table-column
          v-if="sessionFilter == 'unallocated_vehicles'"
          :label="'Description'"
          :prop="'description'"
          :width="$vuetify.display.width <= 1900 ? 500 : ''"
        />
      </el-table>
    </div>

    <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
        <el-row
          class="row-bg"
          justify="space-between"
        >
          <el-col
            :span="5"
            class="d-flex justify-content-start align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col
            :span="8"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col :span="5" class="d-flex justify-content-end align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>

      <div class="custom-pagination" v-if="$vuetify.display.width < 700">
        <el-row
          class="row-bg"
          justify="space-between"
        >
        <el-col
            :span="24"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col
            :span="10"
            class="d-flex justify-content-end align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
              <el-option label="10" :value="'10'" />
              <el-option label="25" :value="'25'" />
              <el-option label="50" :value="'50'" />
              <el-option label="100" :value="'100'" />
              <el-option label="500" :value="'500'" />
              <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col :span="10" class="d-flex justify-content-start align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                 current_page * perPageCount > total_items
                   ? total_items.toLocaleString()
                   : (current_page * perPageCount).toLocaleString()
               }}
               of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>
    </div>
  </el-col>
</template>

<script>
import UserService from "../../../services/user.service";
import {convertToTitleCase, shorterLabel} from "../common/common-tools"
import { exportToExcel } from "../common/exportExcel";

export default {
  props: {
    filterProp: {
      type: Object,
      default: null,
    },
  },
  components: {},
  data() {
    return {
      selectedGroupBy: "1",
      searchBytabs: "site_title",
      sessionFilter: "vehicles",
      sessionDataList: [],
      search: "",
      loading: false,
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      excelDataList: [],
      total: {
        total_count: 0,
        total_usage: 0,
      },
      // Add controller for session data request cancellation
      sessionController: null,

      search_by_dropdown: {
        admin: {
          vehicles_search_by: ['customer', 'vehicle_id', 'make', 'model', 'vehicle_type', 'manufacture_year', 'license_plate', 'site_title', 'created_at', 'updated_at', 'asset_id'],
          unallocated_vehicles_search_by: ['customer', 'vehicle_id', 'make', 'model', 'vehicle_type', 'manufacture_year', 'license_plate', 'site_title', 'asset_id', 'description'],
        },
        user: {
          vehicles_search_by: ['vehicle_id', 'make', 'model', 'vehicle_type', 'manufacture_year', 'site_title', 'created_at', 'updated_at', 'asset_id'],
          unallocated_vehicles_search_by: ['vehicle_id', 'make', 'model', 'vehicle_type', 'manufacture_year', 'site_title', 'asset_id', 'description'],
        },
      },

      selected_order_by: {
            vehicles: 'created_at',
            unallocated_vehicles: 'vehicle_id',
          },
      selected_order_direction: {
            vehicles: 'DESC',
            unallocated_vehicles: 'ASC',
          },
      order_by_dropdown: {
        admin: {
          vehicles_order_by: ['customer', 'vehicle_id', 'make', 'model', 'vehicle_type', 'manufacture_year', 'license_plate', 'site_title', 'created_at', 'updated_at', 'asset_id'],
          unallocated_vehicles_order_by: ['customer', 'vehicle_id', 'make', 'model', 'vehicle_type', 'manufacture_year', 'license_plate', 'site_title', 'asset_id'],
        },
        user: {
          vehicles_order_by: ['vehicle_id', 'make', 'model', 'vehicle_type', 'manufacture_year', 'site_title', 'created_at', 'updated_at', 'asset_id'],
          unallocated_vehicles_order_by: ['vehicle_id', 'make', 'model', 'vehicle_type', 'manufacture_year', 'site_title', 'asset_id' ],
        },
        order_direction_tab: {
          asc: 'ASC',
          desc: 'DESC',
        },
      },

      hasCustomerFilter: false,
      sessionPoller: null, // Store reference to the session poller
    };
  },
  watch: {
    // watch when search by tabs changes
    searchBytabs: function() {
        this.fetchFleetAnalyticsTableData(this.current_page, this.search);
    },

    filterProp: {
      handler: function () {
        // console.log(newValue);
        //this.fetchSessionData(this.current_page, this.search);
        this.handleRefresh();
      },
      deep: true,
    },

    sessionFilter: function () {
      this.cancelSessionRequest();
      this.current_page = 1;
      this.page_size = 50;
      this.perPageCount = 50;
      this.selectedGroupBy = "1";
      this.fetchFleetAnalyticsTableData(this.current_page, this.search);
    },

    current_page: function (newVal) {
      this.current_page = newVal;
      this.fetchFleetAnalyticsTableData(this.current_page, this.search);
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);

      this.fetchFleetAnalyticsTableData(this.current_page, this.search);

    },

    // check if customer filter is applied
    "filterProp.customer_id": {
      handler: function (value, oldValue) {
        this.hasCustomerFilter = value != null && value != "" && value != oldValue;
      },
      deep: true,
    },
  },
  mounted() {
    this.handleRefresh();
  },
  computed: {
    order_by_dropdown_helper() {
      if (!this.$store.state.auth.user) {
        return 'user';
      } else if (this.$store.state.auth.user.is_active && this.$store.state.auth.user.is_admin) {
        return 'admin';
      } else {
        return 'user';
      } 
    },
  },
  methods: {

     convertTabToTitleCase(str){
      return convertToTitleCase(str);
     },

     convertShorterLabel(label, setLength, setMinLength, addOnLabel="") {
      return shorterLabel(label, setLength, setMinLength, addOnLabel);
    },

    // fetch table data
    async fetchFleetAnalyticsTableData(currentPage, search) {

      let page_size = this.perPageCount || 50;
      let page = currentPage || 1;

      let request = {
        customer_id: this.filterProp.customer_id,
        command: this.sessionFilter,
        search_by: this.searchBytabs,
        search: search,
        order_by: this.selected_order_by[this.sessionFilter],
        order_direction: this.selected_order_direction[this.sessionFilter],
      }

      const { response, controller } = UserService.FleetAnalyticsTablesCard(request, page, page_size);

      this.sessionController = controller;

      await response
        .then(
          (response) => {
            if(!response.data || !response.data.data){
              this.sessionDataList = [];
              this.total_items = 0;
              console.log("Fleet analytics table data response is invalid");
              return;
            }

            this.sessionDataList = response.data.data;
            this.total_items = response.data.total_record;
            this.$emit("sessionDataToParent", {
              "totalCount": response.data.total_record,
              "command": response.data.command,
            });

          }
        )
        .catch((error) => {
          console.log("Fleet analytics table data error: ", error.message);
        })
        .finally(() => {
          this.sessionController = null; // Clear controller reference
        });



    },

    /**
     * Cancels the current session data request if one is in progress
     */
    cancelSessionRequest() {
      console.log("cancelSessionRequest");
      if (this.sessionController) {
        this.sessionController.abort();
        this.sessionController = null;
        this.loading = false;
      }
    },

    handleRefresh() {
      this.current_page = 1;
      this.fetchFleetAnalyticsTableData(this.current_page, this.search);
    },

    async downloadFleetAnalyticsXlsx() {
      let page_size = this.perPageCount || 50;
      let page = this.current_page || 1;
      let no_page = true;
      let request = {
        customer_id: this.filterProp.customer_id,
        command: this.sessionFilter,
        search_by: this.searchBytabs,
        search: this.search,
        order_by: this.selected_order_by[this.sessionFilter],
        order_direction: this.selected_order_direction[this.sessionFilter],
      }
      const { response } = UserService.FleetAnalyticsTablesCard(request, page, page_size, no_page);


      await response
        .then(
          (response) => {
            this.excelDataList = response.data.data;
          }
        )
        .catch((error) => {
          console.log("Fleet analytics table data error: ", error.message);
        })
        .finally(() => {
        });
    },

    async loadFleetAnalyticsXlsx(dataList) {
      try {
        // console.log("export excel data list:", dataList);
        const selectedTableTab = this.sessionFilter == 'vehicles' ? "Vehicles" : this.sessionFilter == 'unallocated_vehicles' ? "Unallocated Vehicles" : "";

        let mainTitle = "Fleet Analytics";

        const skipKeysVehicles = ["id", "customer_id", "site_id"];
        const skipKeysUnallocatedVehicles = ["id", "customer_id"];

        const skipKeys = selectedTableTab == 'Vehicles' ? skipKeysVehicles : selectedTableTab == 'Unallocated Vehicles' ? skipKeysUnallocatedVehicles : [];

        const fileName = `${mainTitle}_${selectedTableTab}.xlsx`; // File name
        const newWorksheetName = `${selectedTableTab}`; // Worksheet name
        const title = `${mainTitle} - ${selectedTableTab}`; // Title for the Excel file

        // console.log(fileName, newWorksheetName, title, skipKeys);

        await exportToExcel({
          dataList,
          skipKeys,
          fileName,
          newWorksheetName,
          title,
        });

      } catch (error) {
        console.error("error when download file", error.message);
      }
    },

    async handleExportFile() {

      this.excelDataList = [];

      await this.downloadFleetAnalyticsXlsx();

      if (this.excelDataList && Array.isArray(this.excelDataList) && this.excelDataList.length > 0) {
        await this.loadFleetAnalyticsXlsx(this.excelDataList);
      } else {
        console.log("received empty or invalid datalist when fetching data for excel");
        return;
      }
    },

  },

  beforeUnmount() {
      // Cancel any ongoing session data request
      this.cancelSessionRequest();
    },

};
</script>
